import { useMemo } from "react";
import { useStatusTrackerV2 } from "./useStatusTrackerV2";
import { buildCellViewModel } from "../mappers/cellViewModel.mapper";
import { selectCurrentCells } from "../state/selectors";

// (uniqueKey) → CellVM. Reads the current month's cells + team config from context.
export const useCellViewModel = (uniqueKey) => {
    const { state, team } = useStatusTrackerV2();
    const cells = selectCurrentCells(state);
    const cellInfo = cells[uniqueKey];
    // Spin only when a cell has no data yet; on a refetch, existing cells stay put (the grid
    // is never blanked — the skeleton covers the genuine first-load wait instead).
    const loading = state.loading && !cellInfo;
    const { keyMetrics } = team;
    const acwrThresholdConfig = team.info.acwr_threshold_config;

    // The reducer only replaces the cells it patches, so an untouched cellInfo keeps its
    // identity and this skips the rebuild — dayjs work included — and returns the same VM,
    // which is what lets the memoised cell view skip its render too.
    return useMemo(
        () => buildCellViewModel(cellInfo, { keyMetrics, acwrThresholdConfig, loading }),
        [cellInfo, keyMetrics, acwrThresholdConfig, loading]
    );
};
